import { render } from "./IconNoSearchResult103px.vue?vue&type=template&id=56521b12"
import script from "./IconNoSearchResult103px.vue?vue&type=script&lang=js"
export * from "./IconNoSearchResult103px.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__